import React from 'react';
import { useFulfillmentPlanIdContext } from '../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useEntitiesFulfillmentPlanProperty } from '../../../../hooks/entities/selectors/fulfillment-plans';
import { FulfillmentPlanOrderGridStatus } from '../../../../enums/fulfillmentplan-order-grid-status';

import {
  DelegationDate,
  ExternalFulfillmentCarrier,
  ExternalFulfillmentStatus,
  FulfillmentProvider,
  Rate,
  Service,
  ShipDate,
  TrackingNumber,
} from '../fields';

export const ExternalFulfillmentDisplayContent = () => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const status = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, 'orderGridStatus');

  if (status === FulfillmentPlanOrderGridStatus.PendingFulfillment.name) {
    return (
      <>
        <ExternalFulfillmentStatus />
        <FulfillmentProvider />
        <Service />
        <DelegationDate />
        <Rate />
      </>
    );
  }

  if (status === FulfillmentPlanOrderGridStatus.Shipped.name) {
    return (
      <>
        <ExternalFulfillmentStatus />
        <FulfillmentProvider />
        <Service />
        <DelegationDate />
        <Rate />
        <ShipDate />
        <ExternalFulfillmentCarrier />
        <TrackingNumber />
      </>
    );
  }

  return (
    <>
      <ExternalFulfillmentStatus />
      <FulfillmentProvider />
      <Service />
      <DelegationDate />
      <Rate />
      <ShipDate />
      <ExternalFulfillmentCarrier />
      <TrackingNumber />
    </>
  );
};
